import { GuestMessageGroup } from "./types";

// The 8 guest-facing messages, grouped by the checkout moment they appear at.
// Each id must match the backend whitelist in setMessagesToGuests (stored under
// app_properties.pre_checkout_instructions keyed by id).
export const GUEST_MESSAGE_GROUPS: GuestMessageGroup[] = [
  {
    category: "Messages on Single Order Checkout Page & Close Tab Page",
    messages: [
      { id: "bottom_drink", name: "Bottom of page, if any drinks in cart" },
      { id: "bottom_food", name: "Bottom of page, if any food in cart" },
      { id: "top_always", name: "Top of page, always shown" },
      { id: "bottom_always", name: "Bottom of page, always shown" },
    ],
  },
  {
    category: "Messages on Main Menu Page",
    messages: [{ id: "below_menu_banner", name: "Announcement below menu banner, always shown" }],
  },
  {
    category: "Messages on Checkout Page when Opening a Tab",
    messages: [
      { id: "tab_bottom_drink", name: "Bottom of start a tab page, if any drinks in cart" },
      { id: "tab_bottom_food", name: "Bottom of start a tab page, if any food in cart" },
      { id: "tab_bottom_always", name: "Bottom of start a tab page, always shown" },
    ],
  },
];

// react-quill toolbar, mapped from the legacy TinyMCE config
// (Header 3 + paragraph, bold/italic, align, ordered/bullet lists, link).
export const QUILL_MODULES = {
  toolbar: [
    [{ header: [3, false] }],
    ["bold", "italic"],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

export const QUILL_FORMATS = ["header", "bold", "italic", "align", "list", "link"];

export const ORDER_NUM_DIGITS_OPTIONS = [3, 4, 5];

export const ORDER_NUMBER_PREFIX_MAX_LENGTH = 5;
// The legacy input allowed 18 chars even though the help text says 16; the
// backend truncates to its own limit, so we keep the more permissive input.
export const STATEMENT_DESCRIPTOR_MAX_LENGTH = 18;

// Max upload sizes (bytes) carried over from the legacy FileStack config.
export const MAX_MOBILE_BANNER_BYTES = 300 * 1024;
export const MAX_DESKTOP_BANNER_BYTES = 1024 * 1024;
export const MAX_LOGO_BYTES = 300 * 1024;

// assetType -> save endpoint. assetType values also match deleteCustomerAsset.
export const ASSET_SAVE_ENDPOINTS: Record<string, string> = {
  mobileBanner: "/api/storeMobileBanner",
  desktopBanner: "/api/storeDesktopBanner",
  storeLogo: "/api/storeLogo",
};
